var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { wrap: "", "mx-2": "" } },
    [
      _vm.creationSuccess
        ? _c(
            "v-flex",
            {
              staticClass: "form-success",
              attrs: { xs12: "", md12: "", "mt-3": "" }
            },
            [
              _c("div", [
                _vm._v(_vm._s(_vm.$t(_vm.lblSetting.apartmentCreationSuccess)))
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "form-section",
          attrs: { xs12: "", md6: "", "pl-1": "", "pr-5": "" }
        },
        [
          _c(
            "v-flex",
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("1")]),
                _vm._v(" "),
                _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "primary--text" }, [
                _vm._v(
                  _vm._s(_vm.$t(_vm.lblSetting.apartmentForm.firstSectionTitle))
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            {
              attrs: {
                required: "",
                label: _vm.lblSetting.apartmentForm.correspondingBlock
              }
            },
            [
              _c("base-autocomplete", {
                attrs: {
                  items: _vm.coBlocks,
                  multiple: false,
                  "return-object": false,
                  clearable: true,
                  disabled: _vm.isUpdateAction,
                  "on-fetch-remote": _vm.handleBlockChange,
                  "item-value": "id",
                  "item-text": "name",
                  "is-solo": ""
                },
                model: {
                  value: _vm.block,
                  callback: function($$v) {
                    _vm.block = $$v
                  },
                  expression: "block"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            {
              attrs: {
                required: "",
                label: _vm.lblSetting.apartmentForm.number
              }
            },
            [
              _c("v-text-field", {
                attrs: {
                  counter: 80,
                  maxlength: 80,
                  required: "",
                  rules: _vm.dtRules.numRules,
                  solo: ""
                },
                model: {
                  value: _vm.numApartment,
                  callback: function($$v) {
                    _vm.numApartment = $$v
                  },
                  expression: "numApartment"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.$route.meta.apartment_as_block
            ? [
                _c(
                  "base-control-label-vertical",
                  {
                    attrs: {
                      required: "",
                      label: _vm.lblSetting.apartmentForm.buildingName
                    }
                  },
                  [
                    _c("v-text-field", {
                      attrs: {
                        counter: 80,
                        maxlength: 80,
                        required: "",
                        rules: _vm.dtRules.buildingName,
                        solo: ""
                      },
                      model: {
                        value: _vm.buildingName,
                        callback: function($$v) {
                          _vm.buildingName = $$v
                        },
                        expression: "buildingName"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "base-control-label-vertical",
                  {
                    attrs: {
                      label: _vm.lblSetting.apartmentForm.maintenanceReferent
                    }
                  },
                  [
                    _c("base-multi-select", {
                      key: 4,
                      attrs: {
                        options: _vm.coMaintenanceReferent,
                        "return-object": false,
                        multiple: true,
                        fetch: _vm.handleGetReferent
                      },
                      on: { change: _vm.handleChangeMaintenanceReferent },
                      model: {
                        value: _vm.maintenanceReferents,
                        callback: function($$v) {
                          _vm.maintenanceReferents = $$v
                        },
                        expression: "maintenanceReferents"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "base-control-label-vertical",
                  {
                    attrs: {
                      label: _vm.lblSetting.apartmentForm.vehicleReferent
                    }
                  },
                  [
                    _c("base-multi-select", {
                      key: 5,
                      attrs: {
                        options: _vm.coVehicleReferent,
                        "return-object": false,
                        multiple: true,
                        fetch: _vm.handleGetReferent
                      },
                      on: { change: _vm.handleChangeVehicleReferent },
                      model: {
                        value: _vm.vehicleReferents,
                        callback: function($$v) {
                          _vm.vehicleReferents = $$v
                        },
                        expression: "vehicleReferents"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "base-control-label-vertical",
                  { attrs: { label: _vm.lblSetting.apartmentForm.email } },
                  [
                    _c("v-text-field", {
                      attrs: { counter: 100, maxlength: 100, solo: "" },
                      model: {
                        value: _vm.email,
                        callback: function($$v) {
                          _vm.email = $$v
                        },
                        expression: "email"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "base-control-label-vertical",
                  {
                    attrs: {
                      label: _vm.lblSetting.apartmentForm.landline,
                      "show-error": !_vm.isValidLandline,
                      "error-message": _vm.$t(_vm.lblSetting.landlineValid)
                    }
                  },
                  [
                    _c("vue-tel-input", {
                      key: "1",
                      ref: "tel-landline",
                      staticClass: "mb-4",
                      attrs: {
                        disabledFetchingCountry: true,
                        value: _vm.landline,
                        preferredCountries: [
                          "fr",
                          "ch",
                          "be",
                          "es",
                          "lu",
                          "vn",
                          "us",
                          "gb"
                        ],
                        defaultCountry: _vm.telDefaultCountry,
                        placeholder: _vm.$t(_vm.lblSetting.lblLandline)
                      },
                      on: { onInput: _vm.onInputLandline }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "base-control-label-vertical",
                  {
                    attrs: {
                      label: _vm.lblSetting.apartmentForm.excludeMaintenanceCost
                    }
                  },
                  [
                    _c("v-switch", {
                      staticClass: "mt-0",
                      attrs: { color: "primary" },
                      model: {
                        value: _vm.excludeMaintenanceCost,
                        callback: function($$v) {
                          _vm.excludeMaintenanceCost = $$v
                        },
                        expression: "excludeMaintenanceCost"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "base-control-label-vertical",
                  { attrs: { label: _vm.lblSetting.apartmentForm.address } },
                  [
                    _c("base-address-fields", {
                      model: {
                        value: _vm.address,
                        callback: function($$v) {
                          _vm.address = $$v
                        },
                        expression: "address"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          !_vm.$route.meta.hide_tenant_info
            ? _c(
                "base-control-label-vertical",
                { attrs: { label: _vm.lblSetting.apartmentForm.tenant } },
                [
                  _c("base-autocomplete", {
                    attrs: {
                      items: _vm.coTenants,
                      multiple: true,
                      typeSearchEntity: _vm.coSearchTypes.Tenant,
                      "return-object": false,
                      clearable: false,
                      "on-fetch-remote": _vm.handleGetEntityAutocomplete,
                      "item-value": "id",
                      "is-solo": ""
                    },
                    model: {
                      value: _vm.tenant,
                      callback: function($$v) {
                        _vm.tenant = $$v
                      },
                      expression: "tenant"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.$route.meta.hide_owner_info
            ? _c(
                "base-control-label-vertical",
                { attrs: { label: _vm.lblSetting.apartmentForm.owner } },
                [
                  _c("base-autocomplete", {
                    attrs: {
                      items: _vm.coOwners,
                      multiple: true,
                      typeSearchEntity: _vm.coSearchTypes.Owner,
                      "return-object": false,
                      clearable: false,
                      "on-fetch-remote": _vm.handleGetEntityAutocomplete,
                      "item-value": "id",
                      "is-solo": ""
                    },
                    model: {
                      value: _vm.owner,
                      callback: function($$v) {
                        _vm.owner = $$v
                      },
                      expression: "owner"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "form-section",
          attrs: { xs12: "", md6: "", "pl-3": "", "pr-5": "" }
        },
        [
          _c(
            "v-flex",
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("2")]),
                _vm._v(" "),
                _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "primary--text " }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(_vm.lblSetting.apartmentForm.secondSectionTitle)
                  )
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          !_vm.$route.meta.apartment_as_block
            ? _c(
                "base-control-label-vertical",
                { attrs: { label: _vm.lblSetting.apartmentForm.floor } },
                [
                  _c("v-text-field", {
                    attrs: {
                      counter: 5,
                      maxlength: 5,
                      rules: _vm.dtRules.floorRules,
                      solo: ""
                    },
                    model: {
                      value: _vm.floor,
                      callback: function($$v) {
                        _vm.floor = $$v
                      },
                      expression: "floor"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            { attrs: { label: _vm.lblSetting.apartmentForm.surface } },
            [
              _c("v-text-field", {
                attrs: {
                  counter: 5,
                  maxlength: 5,
                  rules: _vm.dtRules.surfaceRules,
                  solo: ""
                },
                model: {
                  value: _vm.surface,
                  callback: function($$v) {
                    _vm.surface = $$v
                  },
                  expression: "surface"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            { attrs: { label: _vm.lblSetting.apartmentForm.type } },
            [
              _c("v-text-field", {
                attrs: { counter: 20, maxlength: 20, solo: "" },
                model: {
                  value: _vm.type,
                  callback: function($$v) {
                    _vm.type = $$v
                  },
                  expression: "type"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.$route.meta.apartment_as_block
            ? [
                _c(
                  "base-control-label-vertical",
                  { attrs: { label: _vm.lblSetting.apartmentForm.category } },
                  [
                    _c("v-text-field", {
                      attrs: { counter: 20, maxlength: 20, solo: "" },
                      model: {
                        value: _vm.category,
                        callback: function($$v) {
                          _vm.category = $$v
                        },
                        expression: "category"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "base-control-label-vertical",
                  { attrs: { label: _vm.lblSetting.apartmentForm.hub } },
                  [
                    _c("v-text-field", {
                      attrs: { counter: 80, maxlength: 80, solo: "" },
                      model: {
                        value: _vm.hub,
                        callback: function($$v) {
                          _vm.hub = $$v
                        },
                        expression: "hub"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "base-control-label-vertical",
                  { attrs: { label: _vm.lblSetting.apartmentForm.activity } },
                  [
                    _c("v-text-field", {
                      attrs: { counter: 20, maxlength: 20, solo: "" },
                      model: {
                        value: _vm.buildingActivity,
                        callback: function($$v) {
                          _vm.buildingActivity = $$v
                        },
                        expression: "buildingActivity"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "base-control-label-vertical",
                  { attrs: { label: _vm.lblSetting.apartmentForm.function } },
                  [
                    _c("v-text-field", {
                      attrs: { counter: 20, maxlength: 20, solo: "" },
                      model: {
                        value: _vm.buildingFunction,
                        callback: function($$v) {
                          _vm.buildingFunction = $$v
                        },
                        expression: "buildingFunction"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "base-control-label-vertical",
                  {
                    attrs: { label: _vm.lblSetting.apartmentForm.acquisition }
                  },
                  [
                    _c("v-text-field", {
                      attrs: { counter: 20, maxlength: 20, solo: "" },
                      model: {
                        value: _vm.acquisition,
                        callback: function($$v) {
                          _vm.acquisition = $$v
                        },
                        expression: "acquisition"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "base-control-label-vertical",
                  {
                    attrs: {
                      label: _vm.lblSetting.apartmentForm.constructionDate
                    }
                  },
                  [
                    _c("v-text-field", {
                      attrs: { counter: 20, maxlength: 20, solo: "" },
                      model: {
                        value: _vm.constructionDate,
                        callback: function($$v) {
                          _vm.constructionDate = $$v
                        },
                        expression: "constructionDate"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "base-control-label-vertical",
                  { attrs: { label: _vm.lblSetting.apartmentForm.nbParking } },
                  [
                    _c("v-text-field", {
                      attrs: { counter: 20, maxlength: 20, solo: "" },
                      model: {
                        value: _vm.nbParking,
                        callback: function($$v) {
                          _vm.nbParking = $$v
                        },
                        expression: "nbParking"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "base-control-label-vertical",
                  { attrs: { label: _vm.lblSetting.apartmentForm.nbBasement } },
                  [
                    _c("v-text-field", {
                      attrs: { counter: 20, maxlength: 20, solo: "" },
                      model: {
                        value: _vm.nbBasement,
                        callback: function($$v) {
                          _vm.nbBasement = $$v
                        },
                        expression: "nbBasement"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "base-control-label-vertical",
                  { attrs: { label: _vm.lblSetting.apartmentForm.nbFloor } },
                  [
                    _c("v-text-field", {
                      attrs: { counter: 20, maxlength: 20, solo: "" },
                      model: {
                        value: _vm.nbFloor,
                        callback: function($$v) {
                          _vm.nbFloor = $$v
                        },
                        expression: "nbFloor"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8b1246a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8b1246a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/components/block-apartment-vertical-modal/template.html
// module id = null
// module chunks = 